import axios from '../axios';
import util from './util';
const apiPath = 'api/admin/orders';

const orderApi = {
    index: query => {
        return axios.get(
            `${
                process.env.VUE_APP_API_ENDPOINT
            }/${apiPath}/index?${util.queryToString(query)}`
        );
    },
    show: id => {
        return axios.get(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/show/${id}`
        );
    },
    forceConfirm: id => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/${id}/force-confirm`,
            {
                status_code: '200',
                status_message: 'Force Confirm by Admin',
                payment_type: 'admin_force_confirm',
                transaction_status: 'capture',
                fraud_status: 'accept'
            }
        );
    },
    verify: id => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/${id}/verify`
        );
    },
    refund: id => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/${id}/refunded`
        );
    },
    deny: id => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/${id}/deny`
        );
    }
};

export default orderApi;
